module.exports = __webpack_public_path__ + "static/media/projectedGainChevrron.3a7d3c44.svg";